import * as styles from "./Panel.css";
import type { PanelVariants } from "./Panel.css";

import { clsx } from "clsx";
import { type ReactNode } from "react";

type PanelProps = NonNullable<PanelVariants> & {
  children?: ReactNode;
  className?: string;
};

export function Panel({ children, className, hiddenBelow }: PanelProps) {
  return (
    <div className={clsx(styles.panel({ hiddenBelow }), className)}>
      {children}
    </div>
  );
}
